import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { Cat, Thumb, fmt } from './nieuwsUtil';

export default function NieuwsWidget() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get('/nieuws').then((r) => setItems((r.data.items || []).slice(0, 3))).catch(() => {}); }, []);
  if (items.length === 0) return null;
  return (
    <div data-widget-key="nieuws" className="widget">
      <div className="widget-header"><h3>📰 Nieuws</h3></div>
      <div className="widget-content">
        {items.map((n) => (
          <div key={n.id} className="widget-item" onClick={() => nav(`/nieuw/${n.id}`)} style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
            <div style={{ width: 64, height: 48, borderRadius: 8, overflow: 'hidden', flexShrink: 0 }}><Thumb n={n} height={48} fontSize={22} /></div>
            <div style={{ minWidth: 0 }}>
              <div className="widget-item-title" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{n.titel}</div>
              <div className="widget-item-meta"><Cat c={n.categorie} /> <span style={{ marginLeft: 6 }}>{n.bedrijf_id ? n.bedrijf_naam : 'WOMsys'} • {fmt(n.publicatie_datum)}</span></div>
            </div>
          </div>
        ))}
      </div>
      <div className="widget-footer" onClick={() => nav('/nieuw')}>Alle berichten →</div>
    </div>
  );
}
